// Версии юридических документов. Должны совпадать с backend
// `Features/Legal/LegalDocumentVersions.cs`. При изменении любой страницы
// (/privacy, /terms, /offer) обнови соответствующую константу здесь и в C#.

export const LEGAL_DOCUMENT_VERSIONS = {
    privacyPolicy: '2026-05-03',
    termsOfService: '2026-05-03',
    publicOffer: '2026-05-03',
} as const

// LegalConsentType (зеркало backend enum в Entities/LegalConsent.cs).
// Backend сериализует enum как camelCase string (JsonStringEnumConverter).
export const CONSENT_TYPE = {
    pdnProcessing: 'pdnProcessing',
    privacyPolicy: 'privacyPolicy',
    termsAndOffer: 'termsAndOffer',
} as const

// LegalConsentSource.
export const CONSENT_SOURCE = {
    signup: 'signup',
    contactForm: 'contactForm',
} as const
